import { Form, Input, Modal, Spin } from "antd";
import { FormInstance } from "antd/lib";
import React from "react";

interface StationFormProps {
	form: FormInstance;
	submitHandler: () => void;
	onCancel: () => void;
	isLoading: boolean;
	stationEditId?: string;
	isOpen: boolean;
}

const StationForm: React.FC<StationFormProps> = ({
	form,
	submitHandler,
	onCancel,
	isLoading,
	stationEditId,
	isOpen,
}) => {
	return (
		<Modal
			open={isOpen}
			title={`${!stationEditId ? "Add" : "Edit"} Station`}
			okText={`${!stationEditId ? "Add" : "Update"} Station`}
			cancelText="Cancel"
			onCancel={onCancel}
			onOk={submitHandler}
			okButtonProps={{ disabled: isLoading }}
			cancelButtonProps={{ disabled: isLoading }}
		>
			<Spin spinning={isLoading}>
				<Form form={form} requiredMark={false} layout="vertical">
					<Form.Item
						name="call_letters"
						label="Call Letters"
						rules={[{ required: true, message: "This is required field" }]}
					>
						<Input placeholder="Call Letters" />
					</Form.Item>

					<Form.Item
						name="state"
						label="State"
						rules={[{ required: true, message: "This is required field" }]}
					>
						<Input placeholder="State" />
					</Form.Item>

					<Form.Item
						name="city"
						label="City"
						rules={[{ required: true, message: "This is required field" }]}
					>
						<Input placeholder="City" />
					</Form.Item>

					<Form.Item
						name="channel"
						label="Channel"
						rules={[
							{
								type: "number",
								min: 0,
								message: "Channel must be 0 or greater",
								transform: value => (value ? Number(value) : undefined),
							},
						]}
					>
						<Input type="number" placeholder="Channel" min={0} />
					</Form.Item>
				</Form>
			</Spin>
		</Modal>
	);
};

export default StationForm;
